export default __webpack_public_path__ + "static/media/18_2.c7b3ecb5.jpg";